'use strict';

var Events = {
	PAGE: 'page',
	PAGE_ENTER: 'page.enter',
	DESKTOP_FAIL: 'desktop.fail',
	LAZYLOAD_IMAGES: 'lazyload.images',
	LAZYLOAD_SLICK: 'lazyload.slick',
	TREATMENT_TRACKING: 'treatment.selected.tracking',
	LOGIN: 'login',
	LOGIN_LOADED: 'login.loaded',
	SLICK: 'slick',
	SLICK_INIT: 'slick.init',
	SLICK_GOTO: 'slick.goto',
	SLICK_SLIDE: 'slick.slide',
	SLICK_TRACKING: 'slick.tracking',
	FACEBOOK_TRACKING: 'facebook.tracking',

	IMAGE_SEND: 'image.send',
	MODAL_OPEN: 'modal:open',
	MODAL_CLOSE: 'modal:close',
	MODAL_CLOSE_TRACKING: 'modal:close.tracking',
	TERMS_OF_USE: 'termsOfUse',
	PRIVACY_POLICY: 'privacyPolicy',
	FIRST_LOAD_DONE: 'firsLoad.done'
};

module.exports = Events;
